module.exports = __webpack_public_path__ + "img/Xinjiang Uygur-speed.6ce74426.png";